import gql from "graphql-tag";

export const getPublishedContents = gql`
  query GetPublishedContents($where: PublishedContentWhereInput, $odeId: ID){
    publishedContents(where: $where){
      customOdeContent {
        id
        contentGroupsSort
        contentGroups {
          id
          title
          draft
          description
          contentsSort
          creationConfirmed
          contents {
            id
            type
            name
            draft
            materials {
              id
              url,
              type,
              uploadDate,
              fileName
            }
            dueDate
            description
            instructions
            placeType
            placeDirection
            creationConfirmed
            odeContents(
              where: {
                ode: { id: $odeId }
              }
            ) {
              id
              status
              finishDate
              deliverables {
                id
                fileName
                url
                type
                uploadDate
              }
              events {
                id
                event
                description
                createdAt
                blame {
                  id
                  fullName
                  profilePicUrl
                }
              }
            }
          }
        }
      }
      masterContent {
        id
        contentGroupsSort
        contentGroups {
          id
          title
          draft
          description
          contentsSort
          creationConfirmed
          contents {
            id
            type
            name
            draft
            creationConfirmed
            materials {
              id
              url,
              type,
              uploadDate,
              fileName
            }
            description
            dueDate
            instructions
            odeContents(
              where: {
                ode: { id: $odeId }
              }
            ) {
              id
              status
              finishDate
              deliverables {
                id
                fileName
                url
                type
                uploadDate
              }
              events {
                id
                event
                description
                createdAt
                blame {
                  id
                  fullName
                  profilePicUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;
